// @flow
import { FormControl, FormHelperText, FormLabel, TextField } from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { ErrorMessage, FormikProps, FormikProvider } from "formik";
import { useTranslation } from "react-i18next";
import { formControlDefaults, textFieldDefaults } from "../../../../helpers/theme/defaultProps";
import { PAGE_LOGIN } from "../../../../locales/pages/namespaces";
import PasswordInput from "../../../mui/form/passwordInput/passwordInput.jsx";
import './form.css'

type Props = {
	formik: FormikProps,
	loading: Boolean
};

const Form = (props: Props) => {
	const { formik, loading } = props
	const { t } = useTranslation(PAGE_LOGIN)
	
	return (
		<FormikProvider value={formik}>
			<Box
				className={'login-form'}
				sx={{
					padding: {
						xs: '6px 14px',
						sm: '12px 28px',
						md: '46px'
					}
				}}
				component="form"
				onSubmit={formik.handleSubmit}
				noValidate
			>
				<Box
					className={'login-inputs-container'}
				>
					<FormControl
						{...formControlDefaults}
					>
						<FormLabel htmlFor={'username'}>{t('Username')}</FormLabel>
						<TextField
							{...textFieldDefaults}
							autoFocus
							name={'username'}
							value={formik.values.username}
							onChange={formik.handleChange}
							onBlur={formik.handleBlur}
							placeholder={t('Enter your username')}
							slotProps={{
								htmlInput: {
									maxLength: 250,
									"aria-label": t('Username')
								},
								input: {
									autoComplete: 'username'
								}
							}}
							required
						/>
						<FormHelperText>
							<ErrorMessage name={'username'}/>
						</FormHelperText>
					</FormControl>
					<FormControl
						{...formControlDefaults}
					>
						<FormLabel>{t('Password')}</FormLabel>
						<PasswordInput
							formik={formik}
							allowBrowserAutocomplete
							name={'password'}
							required
							value={formik.values.password}
							onChange={formik.handleChange}
							onBlur={formik.handleBlur}
							label={t('Password')}
							otherProps={{
								size: 'small',
								placeholder: t('Password'),
								...textFieldDefaults
							}}
						/>
						<FormHelperText>
							<ErrorMessage name={'password'}/>
						</FormHelperText>
					</FormControl>
					<Button
						color={'secondary'}
						loading={loading}
						fullWidth
						variant="contained"
						type={'submit'}
						sx={{
							paddingTop: '10px',
							paddingBottom: '10px',
						}}
					>
						{t('Login')}
					</Button>
				</Box>
			</Box>
		</FormikProvider>
	);
};

export default Form

